import { c as _c } from "react/compiler-runtime";
import type { OnboardingRequirementCollectDocument, OnboardingSessionConfig } from '@onefootprint/request-types';
import { useEffect } from 'react';
import type { DeviceInfo } from '@/idv2/utils/get-device';
import { trackAction } from '@/idv2/utils/logger';
import { ImgProcessorsContextProvider } from '../components/image-processors';
import { MissingPermissionsSheetProvider } from '../components/missing-permissions-sheet';
import type { NonIdDocCtx } from './context/non-id-doc-context';
import { NonIdDocProvider } from './context/non-id-doc-context';
import Router from './pages/router';
type NonIdDocProps = {
  authToken: string;
  device: DeviceInfo;
  requirement: OnboardingRequirementCollectDocument;
  onboardingConfig: OnboardingSessionConfig;
  onDone: () => void;
};
const NonIdDoc = t0 => {
  const $ = _c(15);
  const {
    authToken,
    device,
    requirement,
    onboardingConfig,
    onDone
  } = t0;
  const t1 = device.initialCameraPermissionState || "prompt";
  let t2;
  if ($[0] !== authToken || $[1] !== device || $[2] !== onboardingConfig || $[3] !== requirement || $[4] !== t1) {
    t2 = {
      authToken,
      device,
      requirement,
      config: onboardingConfig,
      allowPdf: true,
      cameraPermissionState: t1
    };
    $[0] = authToken;
    $[1] = device;
    $[2] = onboardingConfig;
    $[3] = requirement;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const initialContext = t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  useEffect(_temp, t3);
  let t4;
  if ($[7] !== onDone) {
    t4 = <ImgProcessorsContextProvider><Router onDone={onDone} /></ImgProcessorsContextProvider>;
    $[7] = onDone;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== device || $[10] !== t4) {
    t5 = <MissingPermissionsSheetProvider device={device}>{t4}</MissingPermissionsSheetProvider>;
    $[9] = device;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== initialContext || $[13] !== t5) {
    t6 = <NonIdDocProvider initialContext={initialContext}>{t5}</NonIdDocProvider>;
    $[12] = initialContext;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
export default NonIdDoc;
function _temp() {
  trackAction("non-id-doc:started");
}